import { css } from "@tento-ui/component-styles";
import { ChatThemes } from "../chat-theme";
import type { ChatTheme } from "../chat-theme";

/**
 * The chatgpt.com replica (dark): #212121 ground; user messages in a
 * #303030 bubble, ~24px radius, right-aligned at 70% width; assistant
 * full-width sans 16px/1.75; code panels #0d0d0d.
 */
export const ChatGptLook: ChatTheme = {
  ...ChatThemes.bubbles(),
  name: "chatgpt",
  $style: css`
    :host {
      background: #212121;
      color: #ececec;
      --text-pri: #ececec;
      --text-sec: #b4b4b4;
      --text-ter: #8e8e8e;
      font-family: ui-sans-serif, -apple-system, "Segoe UI", Helvetica,
        Arial, sans-serif;
      font-size: 16px;
      line-height: 1.75;
      --thread-top-inset: 20px;
      --thread-bottom-inset: 20px;
      --chat-turn-inset: max(20px, calc((100% - 768px) / 2));
      --chat-bubble-ground: #303030;
      --chat-bubble-ink: #ececec;
      --chat-bubble-radius: 24px;
      --chat-bubble-max-width: 70%;
      --chat-bubble-padding: 10px 20px;
      --chat-bubble-leading: 1.6;
      --chat-terminal-bg: #0d0d0d;
      --chat-terminal-fg: #ececec;
      --chat-terminal-size: 13px;
      --chat-terminal-padding: 12px 16px;
      --chat-terminal-radius: 8px;
      --session-replay-ansi-ground: #0d0d0d;
      /* SGR yellow (the tsh accent role) is noise on this ground — any
         captured marker stands down to chatgpt's own dim gray. */
      --session-replay-ansi-yellow: #8e8e8e;
      /* Markdown chrome on the dark ground: chatgpt's own light link
         blue (the product default --blue is a light-theme ink), and a
         dim quote bar. */
      --chat-link-ink: #66b5ff;
      --divider: #494949;
      /* Tool calls are chatgpt's dark activity panel: the CARD is the
         bubble (it inherits the code-panel ground), padded like one, and
         expanding separates the output with a full-width hairline —
         square, not rounded, running edge to edge of the panel. */
      --chat-toolcall-padding: 10px 16px;
      --chat-toolcall-output-bg: transparent;
      --chat-toolcall-output-radius: 0;
      --chat-toolcall-output-inset: 0;
      --chat-toolcall-divider: 1px solid
        color-mix(in srgb, currentColor 18%, transparent);
    }
  `,
};
